(function () {
    'use strict';

    angular
        .module('app.application')
        .controller('ApplicationAddController', ApplicationAddController);

    /* @ngInject */
    function ApplicationAddController(
        logger,
        applicationService,
        $uibModalInstance,
        moment) {

        var vm = this;
        vm.title = 'Add Application';
        vm.application = applicationService.getDefaultApplication();
        vm.applicationFields = applicationService.getApplicationFields();

        vm.save = save;
        vm.reset = reset;

        activate();

        function activate() {
            setForm();
            logger.info('Activated User Add View');
        }

        function save() {
            if (vm.applicationForm.$valid) {
                vm.application.DateUpdated = moment().toDate();
                applicationService.saveApplication(vm.application)
                    .then(function (result) {
                        if (result.status === 200) {
                            result.data.ApplicationType = vm.application.ApplicationType;
                            $uibModalInstance.close(result.data);
                        } else {
                            logger.info('issue saving application');
                        }
                    });
            }
        }

        function reset() {
            vm.applicationForm.options.resetModel();
            $uibModalInstance.dismiss('cancel');
        }

        function setForm() {
        }
    }
})();
